import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight.js';
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill.js';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill.js';
// nm2024 themed components
import { LinkNm2024  } from '../../../../nm2024Theme/components/link/styles';
import { TypographyNm2024  } from '../../../../nm2024Theme/components/typography/styles';
import Accordion from '../../../../nm2024Theme/components/accordion';
// styles
import {
  LinkStyled,
  SectionContainerStyled,
} from './styles';

export default () => (
  <SectionContainerStyled
    id='home-faq'
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}>
        <TypographyNm2024
          component='h2'
          nextElement='typography'
          typeface='serif'>
          Questions about Northwestern Mutual&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </TypographyNm2024>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-home'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'home-products-and-services-faq',
              title: <>How much can I expect to pay for your products <WidowBlock>and services&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <TypographyNm2024 nextElement='typography'>
                    Our pricing for insurance and fees for investing are straightforward, and we&#39;ll always be upfront about them. What you pay monthly &#40;or yearly&#41; for our insurance solutions is determined by things like the amount of coverage you need and your age. For an{' '}
                    <LinkNm2024
                      id='home-products-and-services-faq-advisory-link'
                      linkUrl='/investments/investment-advisory-services/'
                      variant='primaryDeemphasize'>
                      advisory
                    </LinkNm2024>
                    {' '}or{' '}
                    <LinkNm2024
                      id='home-products-and-services-faq-private-wealth-management-link'
                      linkUrl='/private-wealth-management/'
                      variant='primaryDeemphasize'>
                      private wealth management
                    </LinkNm2024>
                    {' '}investment account, you&#39;ll pay a quarterly fee. The fee is based on the value of the assets in your account. Our{' '}
                    <LinkNm2024
                      id='home-products-and-services-faq-brokerage-accounts-and-services-link'
                      linkUrl='/investments/brokerage-accounts-services/'
                      variant='primaryDeemphasize'>
                      brokerage accounts and services
                    </LinkNm2024>
                    {' '}work on a commission for each asset purchased.
                  </TypographyNm2024>
                  <TypographyNm2024 disableBottomPadding>
                    Find out how your advisor can help you.{' '}
                    <LinkNm2024
                      id='home-products-and-services-faq-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Connect with one now
                    </LinkNm2024>.
                  </TypographyNm2024>
                </>
              ),
            },
            {
              id: 'home-how-is-nm-different-faq',
              title: <>How is Northwestern Mutual different <WidowBlock>from others&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <TypographyNm2024 nextElement='typography'>
                    We&#39;ll show you a better way to money. It starts with a conversation about your life and questions about what&#39;s important to you. Your advisor&#39;s expertise will help reveal blind spots and identify the opportunities that others might overlook. As you work together, your advisor will tailor your plan from our exclusive portfolio of financial products. Each solution is designed to meet you where you are, at every stage in your life. That way, you&#39;ll have the confidence to live the way you want now, and down the road.
                  </TypographyNm2024>
                  <TypographyNm2024 disableBottomPadding>
                    Ready to get started&#63;{' '}
                    <LinkNm2024
                      id='home-how-is-nm-different-faq-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Connect with your advisor now
                    </LinkNm2024>.
                  </TypographyNm2024>
                </>
              ),
            },
            {
              id: 'home-products-offered-faq',
              title: <>What products and services does Northwestern <WidowBlock>Mutual offer&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <TypographyNm2024 nextElement='typography'>
                    Your plan will work its hardest with the right solutions tailored to your goals. You&#39;ll have access to our exclusive portfolio of financial products that reinforce each other. Depending on your goals, there&#39;s{' '}
                    <LinkNm2024
                      id='home-products-offered-faq-investments-link'
                      linkUrl='/investments/'
                      variant='primaryDeemphasize'>
                      investments
                    </LinkNm2024>
                    {' '}to help grow your money,{' '}
                    <LinkNm2024
                      id='home-products-offered-faq-insurance-link'
                      linkUrl='/insurance/'
                      variant='primaryDeemphasize'>
                      insurance
                    </LinkNm2024>
                    {' '}to protect what you&#39;ve earned, and{' '}
                    <LinkNm2024
                      id='home-products-offered-faq-annuities-link'
                      linkUrl='/annuities/'
                      variant='primaryDeemphasize'>
                      annuities
                    </LinkNm2024>
                    {' '}for extra income when you retire.
                  </TypographyNm2024>
                  <TypographyNm2024 disableBottomPadding>
                    Talk to your advisor about which options might be best for you.{' '}
                    <LinkNm2024
                      id='home-products-offered-faq-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with one now
                    </LinkNm2024>.
                  </TypographyNm2024>
                </>
              ),
            },
            {
              id: 'home-how-can-a-financial-advisor-help-me',
              title: <>How can a financial advisor <WidowBlock>help me&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <TypographyNm2024 nextElement='typography'>
                    Your advisor will be your trusted partner who&#39;ll help you reach your goals, no matter how big or small. They&#39;ll ask deeper questions and listen closely to fully understand your priorities. With a holistic view of your financial picture in focus, they&#39;ll tailor your plan with our exclusive portfolio of financial products. Each solution is designed to meet you where you are, at every stage in your life.
                  </TypographyNm2024>
                  <TypographyNm2024 disableBottomPadding>
                    Get a feel for what it will be like to{' '}
                    <LinkNm2024
                      id='home-how-can-a-financial-advisor-help-me-fafa-link'
                      linkUrl='/financial-advisor/'
                      variant='primaryDeemphasize'>
                      work with your advisor
                    </LinkNm2024>.
                  </TypographyNm2024>
                </>
              ),
            },
            {
              id: 'home-what-is-a-financial-plan-exactly',
              title: <>What is a financial <WidowBlock>plan, exactly&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <TypographyNm2024>
                    A financial plan will help you make the most of what you have, no matter how much you have, so you can live the life you&#39;ve always wanted. It takes into account all of your goals, shows you what it&#39;ll take to get there, the progress you&#39;ve already made, any gaps you might have, and your opportunities.
                  </TypographyNm2024>
                  <TypographyNm2024>
                    Your plan starts with a conversation with your advisor. They&#39;ll ask deeper questions and listen closely to fully understand your goals and what&#39;s most important to you. With a holistic view of your financial picture in focus, you&#39;ll work with your advisor to tailor your plan from our exclusive portfolio of financial products. Each solution is designed to meet you where you are, at every stage in your life.
                  </TypographyNm2024>
                  <TypographyNm2024>
                    <LinkNm2024
                      id='home-what-is-a-financial-plan-exactly-link'
                      linkUrl='/financial-planning/'
                      variant='primaryDeemphasize'>
                      See how our approach to financial planning is a better way to money
                    </LinkNm2024>.
                  </TypographyNm2024>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <TypographyNm2024 disableBottomPadding>
          Already a client&#63;&nbsp;
          <LinkStyled
            linkUrl='/faq/'
            variant='primaryDeemphasize'
            endAdornment={CaratRight}
            endAdornmentStylesReset
            ariaLabel='Continue to Frequently Asked Questions page'>
            Try these FAQs
          </LinkStyled>
        </TypographyNm2024>
      </Col>
    </Row>
  </SectionContainerStyled>
);
